<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex-grow">
                <div class="vx-row">
                    <div style="display:inline-block" class="vx-col lg:w-1/3 md:w-1/2 w-full">
                        <label class="vs-input--label">{{ this.$t('updateInout.branch') }}</label>
                        <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                                  :options="organizationBranchOptions">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div>
                    <div style="display:inline-block" class="vx-col lg:w-1/3 md:w-1/2 w-full">
                        <label class="vs-input--label">{{ this.$t('updateInout.employee') }}</label>
                        <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div>
                    <div style="display:inline-block" class="vx-col lg:w-1/3 md:w-1/2 w-full lg:mt-0 mt-4">
                        <label class="vs-input--label">{{ this.$t('updateInout.status') }}</label>
                        <v-select class="" v-model="inOutStatusModel" :clearable="false" :options="leaveStatusOptions">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div>
                    <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                        <label class="vs-input--label">{{ this.$t('updateInout.time') }}: </label>
                        <date-range-picker
                            ref="picker" class="w-full"
                            :locale-data="{format: 'dd/mm/yyyy' }"
                            :opens="'right'"
                            @update="dateRangePicker"
                            v-model="dateRange">
                        </date-range-picker>
                    </div>
                    <div class="vx-col lg:w-1/3 md:w-1/2 w-full lg:mt-10 mt-8">
                        <vs-input class="w-full"
                                  v-model="searchQuery"
                                  @input="updateSearchQuery" :placeholder="$t('button.search')"/>
                    </div>
                    <div class="vx-col w-full mt-6">
                        <div class="flex">
                            <vs-button @click="filter" icon-pack="feather" icon="icon-search">
                                {{ this.$t('updateInout.search') }}
                            </vs-button>
                            <vs-button class="ml-5" @click="addInOut" iconPack="feather" icon="icon-plus" type="border"
                                       v-if="isPermissionAdd()">{{ $t('updateInout.create') }}
                            </vs-button>
                            <vs-button class="ml-5" @click="generateReport" iconPack="feather" icon="icon-download"
                                       type="border">{{ $t('updateInout.export') }}
                            </vs-button>
                        </div>
                    </div>
                </div>
<!--                <div class="vx-row">-->
<!--                    <div style="display:inline-block" class="vx-col md:w-1/3 sm:w-auto mt-2 w-full">-->
<!--                        <label class="vs-input&#45;&#45;label">{{this.$t('updateInout.status')}}</label>-->
<!--                        <v-select class="" v-model="inOutStatusModel" :clearable="false" :options="leaveStatusOptions">-->
<!--                            <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>-->
<!--                        </v-select>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="inOutData"
                         :animateRows="true"
                         paginationPageSize="50"
                         :pagination="true"
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :localeText="{noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         :autoSizeStrategy="autoSizeStrategy"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000"
                         :tooltipMouseTrack="true">
            </ag-grid-vue>

            <div class="vx-row mt-8" v-if="totalElements > 0">
                <div style="min-width:200px" class="vx-col md:w-1/2 w-full">
                    <span class="content-page font-bold">Hiển thị: </span>
                    <span class="text-page">
                        {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{ totalElements }}
                    </span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination
                        :total="totalPages"
                        v-model="currentPage"
                        @change="loadPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import Pagination from "../../ui-elements/Pagination.vue";
import flatPickr from 'vue-flatpickr-component';
import DateRangePicker from "../../../components/vue2-daterange-picker/components/DateRangePicker";
import 'flatpickr/dist/flatpickr.css';
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import authConfig from '@/../auth_config.json';
import {isAPI, isRouter} from '../../../store/permission';
import {constAPI, constRouter} from '../../../store/constant';

export default {
    components: {
        AgGridVue,
        vSelect,
        CellRendererActions,
        CellRendererStatus,
        Datepicker,
        Pagination,
        DateRangePicker,
        flatPickr,
    },
    data() {
        return {
            //isInitComplete: false,
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    width: 100,
                    suppressSizeToFit: true,
                },
                {
                    headerName: this.$t('updateInout.employeeCode'),
                    field: 'employeeCode',
                    minWidth: 150,
                    tooltipField: 'employeeCode',
                    suppressSizeToFit: true,
                },
                {
                    headerName: this.$t('updateInout.employeeName'),
                    field: 'fullName',
                    minWidth: 180,
                    tooltipField: 'fullName',
                },
                {
                    headerName: this.$t('updateInout.date'),
                    field: 'displayInOutDate',
                    minWidth: 150,
                    tooltipField: 'displayInOutDate',
                },
                {
                    headerName: this.$t('updateInout.shift'),
                    field: 'workShiftName',
                    minWidth: 150,
                    tooltipField: 'workShiftName'
                },
                {
                    headerName: this.$t('updateInout.timeInOut'),
                    field: 'workTime',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('updateInout.status'),
                    field: 'displayStatus',
                    minWidth: 100,
                    cellRenderer: 'CellRendererStatus'
                },
                {
                    headerName: this.$t('updateInout.reason'),
                    field: 'reason',
                    minWidth: 165,
                    tooltipField: 'reason'
                },
                {
                    headerName: this.$t('updateInout.createDate'),
                    field: 'createDateStr',
                    minWidth: 165,
                },
                {
                    headerName: this.$t('updateInout.actions'),
                    field: 'actions',
                    minWidth: 200,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                    pinned: 'right',
                },
            ],
            inOutData: [],
            employeeOptions: [
                {value: null, label: this.$t('menuOrganization.all')}
            ],
            leaveStatusOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: 0, label: this.$t('overTime.wait')},
                {value: 1, label: this.$t('overTime.approved')},
                {value: 2, label: this.$t('statusActive.decline')},
                {value: 3, label: this.$t('statusActive.cancel')}
            ],
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            selectedStatus: null,
            status: null,
            valueSelectedBranch: null,
            dateRange: {
                endDate: new Date(),
                startDate: moment().subtract(7, 'days').toDate(),
            },
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.isUpdateEmployee'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_EMPLOYEE', false);
            }
        }
    },
    computed: {
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value;
                this.selectedEmployeeValue = null;
                this.loadEmployee()
            }
        },
        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.selectedEmployeeValue),
                    value: this.selectedEmployeeValue
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        },
        inOutStatusModel: {
            get() {
                return {
                    label: this.leaveStatusOptions.find(x => x.value == this.status).label,
                    value: this.status
                }
            },
            set(obj) {
                this.status = obj.value;
            }
        },
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.update_in_out_add)
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        addInOut() {
            this.$router.push(`/user/update-in-out-by-id?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value == id);
            return (organizationBranch && organizationBranch.label) || 'Chưa xác định';
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value == id);
            return (employee && employee.label) || 'Chưa xác định';
        },
        loadEmployee() {
            if (!this.selectedOrganizationBranchValue) return;

            this.$vs.loading();
            this.$crm.post('/employee/find-by-organization-branch/' + this.selectedOrganizationBranchValue).then((response) => {
                this.employeeData = response.data;
                this.employeeOptions = response.data.map(item => {
                    return {
                        value: item.employeeId,
                        label: item.employeeCode + "_" + item.fullName,
                        ...item
                    }
                });
                this.employeeOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
                this.$vs.loading.close();
                this.loadInOut();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            this.loadInOut();
        },
        loadInOut() {
            // if (!this.selectedOrganizationBranchValue) return;
            // if (new Date(this.dateRange.startDate && this.dateRange.endDate).getTime() > new Date().getTime()){
            //     return this.$vs.notify({
            //         title: 'Có lỗi sảy ra!',
            //         text: "Thời gian xem không được ở tương lai.",
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'danger'
            //     });
            // }
            let condition = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployeeValue,
                status: this.status,
                fromDate: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                toDate: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 0})
            }
            this.$vs.loading();
            this.$crm.post('/work-shift/employee/admin-find-update-in-out', condition).then((response) => {
                this.$vs.loading.close();
                this.inOutData = response.data.map(item => {
                    item.stt = 50 * (this.currentPage - 1) + response.data.indexOf(item) + 1;
                    item.createDateStr = moment(item.createDate).format("HH:mm DD/MM/YYYY")
                    item.displayInOutDate = moment(item.date).format("DD/MM");
                    item.displayLeaveType = item.leaveType == 0 ? 'Nghỉ phép' : 'Nghỉ thường';
                    item.displayInOutTime = moment(item.startHour).format("HH:mm") + ' - ' + moment(item.endHour).format("HH:mm");
                    item.displayStatus = item.status == 0 ? 'Chờ' : item.status == 1 ? 'Đã duyệt' : item.status == 2 ? 'Từ chối' : 'Hủy';
                    let employee = this.employeeOptions.find(employee => employee.employeeId == item.employeeId);
                    let start = moment(item.startHour).format("HH:mm")
                    let end = moment(item.endHour).format("HH:mm")
                    item.workTime = start + " - " + end;
                    let mergeData = {...item, ...employee}
                    mergeData.id = item.id;
                    return mergeData;
                });
                this.inOutData.sort((a, b) => b.id - a.id)
                this.inOutData = this.inOutData.filter(el => el.fullName);
                this.countElementPage = this.currentPage * 20;
                this.totalElements = this.inOutData.length;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        generateReport() {
            let payload = {
                fromDate: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                toDate: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 0}),
                employeeId: this.selectedEmployeeValue,
                organizationBranchId: this.selectedOrganizationBranchValue,
                status: this.status
            }

            this.$vs.loading()
            this.$crm.post('/work-shift/employee/export', payload).then(res => {
                window.open(authConfig.crmDomain + "file/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.err,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        filter(){
            this.currentPage = 1;
            this.loadInOut();
            if (this.gridApi) this.gridApi.paginationGoToPage(this.currentPage - 1)
        }
    },
}
</script>

<style scoped>
.vue-daterange-picker .ranges {
    float: right;
    border-left: 1px solid #ddd;
}

.daterangepicker {
    border-left: none !important;
}

.title-page {
    font-size: 2.2rem;
    font-weight: bold;
    display: flex;
}

.text-font {
    opacity: 0.7;
}

.reportrange-text {
    border-radius: 5px;
    height: 38px;
    line-height: 27px;
}

.mt-26 {
    margin-top: 26px;
}
</style>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
